import { j as r } from "../../jsx-runtime.BREq8dyb.js";
import { parse as n } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon as i } from "@fortawesome/react-fontawesome";
import { memo as m, isValidElement as o, cloneElement as f } from "react";
const s = (t) => {
  try {
    return n.icon(t) !== null;
  } catch {
    return !1;
  }
}, l = m(({
  icon: t,
  iconProps: e
}) => t ? o(t) ? f(t, e || {}) : typeof t == "function" ? /* @__PURE__ */ r.jsx(t, { ...e || {} }) : typeof t == "string" ? /* @__PURE__ */ r.jsx("img", { alt: "Icon", src: t, ...e || {} }) : s(t) ? /* @__PURE__ */ r.jsx(i, { ...e || {}, icon: t }) : null : null);
l.displayName = "DqIcon";
export {
  l as default
};
//# sourceMappingURL=DqIcon.js.map
